export default class Company {
    constructor(raw = {}) {
        this.id = raw.id ?? "-1";
        this.name = raw.name ?? "";
        this.location = raw.location ?? "";
        this.notificationEmail = raw.notificationEmail ?? "";
        this.ccPersonsForCertificate = raw.ccPersonsForCertificate ?? "";
        this.trustedCustomer = raw.trustedCustomer ?? false;
        this.departments = raw.departments ?? [];
        this.designInfo = raw.designInfo ?? "";
        this.linkToAdmin = raw.linkToAdmin ?? "";
        this.billomatId = raw.billomatId ?? "";
        this.woocommerceId = raw.woocommerceId ?? "";
    }
}
